/* @flow */

export default class InvoiceFilters {
  statusKeys: string[];

  constructor() {
    this.statusKeys = [];
  }
}
